'use client';

import { useCallback } from 'react';

import { trackEvent } from '../core';
import { normalizeTrackingValue } from '../utils';

const YOUTUBE_PLAYER_STATE = {
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
} as const;

/**
 * CAUTION: `getVideoData` seems to be undocumented and unofficial.
 */
export interface YouTubeStateChangeEvent {
  data: number;
  target: {
    getVideoData?: () => { title?: string; video_id?: string };
  };
}

/**
 * Tracks video-play, video-pause, and video-completed.
 */
export function useYouTubePlaybackChangeHandler(): (
  event: YouTubeStateChangeEvent,
) => void {
  return useCallback((event: YouTubeStateChangeEvent) => {
    const videoData = event.target.getVideoData?.();
    const title = normalizeTrackingValue(videoData?.title);
    const videoId = videoData?.video_id;

    switch (event.data) {
      case YOUTUBE_PLAYER_STATE.ENDED:
        trackEvent({
          event_name: 'video-completed',
          video_name: title,
          video_id: videoId,
        });
        break;
      case YOUTUBE_PLAYER_STATE.PLAYING:
        trackEvent({
          event_name: 'video-play',
          video_name: title,
          video_id: videoId,
        });
        break;
      case YOUTUBE_PLAYER_STATE.PAUSED:
        trackEvent({
          event_name: 'video-pause',
          video_name: title,
          video_id: videoId,
        });
        break;
    }
  }, []);
}
